import script from "./AuthSupa.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthSupa.vue?vue&type=script&lang=ts&setup=true"

import "./AuthSupa.vue?vue&type=style&index=0&id=33a319c8&lang=css"

const __exports__ = script;

export default __exports__